/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Shopping_Api_Models_BrandingImage = {
  brandingImageType?: Luci_Shopping_Api_Models_BrandingImage.brandingImageType;
  id?: number;
  url?: string;
  height?: number;
  width?: number;
  byteCount?: number;
};
export namespace Luci_Shopping_Api_Models_BrandingImage {
  export enum brandingImageType {
    LOGO = 'Logo',
    FAVICON = 'Favicon',
    HEADER = 'Header',
    LOYALTY_CARD_LOGO = 'LoyaltyCardLogo',
  }
}

